module.exports = __webpack_public_path__ + "static/media/trophy (1).9c7493a7.svg";